export default "__VITE_ASSET__BK4CbXJ$__"